<template>
  <div class="popup">
    <div class="close" @click="$emit('close')">
        <i class="material-icons" @click="deleteRow(index)">close</i>
    </div>

    <el-form>
      <el-form-item label="Bulk add">
        <el-input type="textarea" v-model="bulk"></el-input>

        <el-button @click="addModels">Toevoegen</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      bulk: ''
    }
  },
  methods: {
      addModels(index) {
        let bulk = this.bulk

        let lines = bulk.split(/\n/);
        let output = [];
        let outputText = [];
        for (var i = 0; i < lines.length; i++) {
          if (/\S/.test(lines[i])) {
            //outputText.push('"' + $.trim(lines[i]) + '"');
            //output.push($.trim(lines[i]));
            this.models.push({
              show: true,
              sku: lines[i]
            })
          }
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// Bulk-popup.vue?67510bfb